<template>
  <div>
    <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
      <v-card>
        <v-toolbar dense class="">
          <v-toolbar-title>Upload Stats with AI</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
          <!-- Popup content -->
          <v-card>
            <v-card-text>
              <v-tabs v-model="activeTab" fixed-tabs background-color="primary">
                <v-tab class="primary--text" style="background:white;">Use Submitted Stats</v-tab>
                <v-tab class="primary--text" style="background:white;">Upload Stats</v-tab>
              </v-tabs>
              <v-tabs-items v-model="activeTab">
                <v-tab-item>
                  <v-container>
                    <h4 v-if="!imagesToView">
                      Empty Submissions
                    </h4>
                    <div v-if="imagesToView">
                      <!-- <v-row>
                        <v-col
                          cols="12"
                          md="12"
                          xs="12"
                        >
                          <v-row align="center" justify="center">
                            <v-col v-for="(img, index) in payoutUploads" :key="index" cols="4" md="4" lg="4" sm="3">
                                <v-hover v-slot:default="{ hover }">
                                  <v-card flat class="mx-auto" :elevation="hover ? 16 : 2">
                                    <v-img
                                      :src="img"
                                      :lazy-src="img"
                                      aspect-ratio="1"
                                      class="grey lighten-2"
                                    ></v-img>
                                    <v-checkbox
                                      v-model="selectedImages"
                                      :value="img"
                                      @change="toggleImage(img)"
                                      style="position: absolute; top: -20px; right: -10px;"
                                      hide-details
                                    ></v-checkbox>
                                  </v-card>                                     
                                </v-hover>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row> -->
                      <!-- posts -->
                      <div class="pb-5" v-if="hasPosts">
                        <div class="h3 mt-2">
                          <span>Posts</span>
                          <!-- <v-checkbox
                            v-model="checkbox.post"
                            value="post"
                            @change="changePostImage(imagesToView.posts)"
                            hide-details
                            style="margin-top: -3px;"
                          ></v-checkbox> -->
                          <div @click="changeContentImage(imagesToView.posts)">
                            <v-radio-group style="margin-top: -3px;" v-model="checkbox.post" dense row>
                              <v-radio dense value="post" label="Select this Content" class="justify-center" style="font-size: 13px;"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>
                        <v-divider class="ma-0 mb-4"></v-divider>
                        <div class="mb-5" :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.posts">
                          <v-row justify="start" align="left">
                            <v-col md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in allPost.images">
                              <v-card text tile>                      
                                <v-hover>
                                  <video
                                  v-if="getMediaType(img.url) === 'video'"
                                  width="180px"
                                  height="200px"
                                  :src="img.url"
                                  controls>             
                                      Your browser does not support the video tag.
                                  </video>
                                  <v-img
                                    :src="img.url"
                                    :lazy-src="img.url"
                                    aspect-ratio="1"
                                    class="grey lighten-2 mx-auto"
                                    slot-scope="{ hover }"
                                    :class="`elevation-${hover ? 12 : 2}`"
                                    @click="viewMedia(img.url)"
                                    v-else
                                  />
                                </v-hover>
                              </v-card>
                            </v-col>
                            <v-col class="pt-0" md="12" xs="12" v-if="allPost.instagramPostURL !== '' || allPost.images.length > 0">
                              <a :href="allPost.instagramPostURL" target="_blank">
                                <v-btn small text color="warning" class="mt-2"> {{ allPost.instagramPostURL }}</v-btn>
                              </a>
                            </v-col>
                            <!-- <v-col md="12" xs="12" v-if="allPost.instagramPostURL !== '' || allPost.images.length > 0">
                              <v-divider class="ma-0"></v-divider>
                            </v-col> -->
                          </v-row>
                        </div>
                      </div>

                      <!-- posts -->
                      <div class="pb-5" v-if="hasStories">
                        <div class="h3 mt-2">
                          <span>IG Stories</span>
                          <!-- <v-checkbox
                            v-model="checkbox.story"
                            value="story"
                            @change="changeStoryImage(imagesToView.stories)"
                            hide-details
                            style="margin-top: -3px;"
                          ></v-checkbox> -->
                          <div @click="changeStoryImage(imagesToView.stories)">
                            <v-radio-group style="margin-top: -3px;" v-model="checkbox.story" dense row>
                              <v-radio dense value="story" label="Select this Content" class="justify-center" style="font-size: 13px;"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>
                        <v-divider class="ma-0 mb-4"></v-divider>
                        <div class="mb-5" :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.stories">
                          <v-row justify="left" align="left">
                            <v-col class="mb-0 pb-0" md="12" xs="12" v-if="allPost.label">
                              <div class="subtitle-1">{{allPost.label}}</div>
                            </v-col>
                            <v-col class="pt-1" md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in allPost.images">
                              <v-card text tile>                      
                                <v-hover>
                                  <video
                                  width="180px"
                                  height="200px"
                                  v-if="getMediaType(img.url) === 'video'"
                                  :src="img.url"
                                  controls>             
                                      Your browser does not support the video tag.
                                  </video>
                                  <v-img
                                    :src="img.url"
                                    :lazy-src="img.url"
                                    aspect-ratio="1"
                                    class="grey lighten-2 mx-auto"
                                    slot-scope="{ hover }"
                                    :class="`elevation-${hover ? 12 : 2}`"
                                    @click="viewMedia(img.url)"
                                    v-else
                                  />
                                </v-hover>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <!-- Deliverables -->
                      <div class="pb-5" v-if="hasDeliverablePosts">
                        <div class="h3 mt-2">Contents</div>
                        <v-divider class="ma-0 mb-4"></v-divider>
                        <div :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.deliverablePosts">
                          <div v-if="filterEmptyPosts(allPost.posts).length > 0">
                            <div class="subtitle-1 font-weight-bold d-flex flex-row justify-space-between">
                              <span>{{getLongPostTitle(allPost.type)}}</span>
                              <!-- <v-checkbox
                                v-model="checkbox.content"
                                value="content"
                                @change="changeContentImage(allPost.posts)"
                                hide-details
                                style="margin-top: -3px;"
                              ></v-checkbox> -->
                              <div @click="changeContentImage(allPost.posts)">
                                <v-radio-group style="margin-top: -3px;" v-model="checkbox.content" dense row>
                                  <v-radio dense :value="`content${firstIndex}`" label="Select this Content" class="justify-center" style="font-size: 13px;"></v-radio>
                                </v-radio-group>
                              </div>
                            </div>
                            <v-row justify="left" align="left" v-for="(post, pIndex) in filterEmptyPosts(allPost.posts)" :key="pIndex">
                              <v-col md="12" xs="12" class="pt-5 pb-0" v-if="post.label && getPostType(allPost.type) === 'label'">
                                <div class="subtitle-2" v-if="getPostType(allPost.type) === 'label'">{{post.label}}</div>
                              </v-col>
                              <v-col md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in post.images">
                                <v-card text tile>                      
                                  <v-hover>
                                    <video
                                    width="180px"
                                    height="200px"
                                    v-if="getMediaType(img.url) === 'video'"
                                    :src="img.url"
                                    controls>             
                                        Your browser does not support the video tag.
                                    </video>
                                    <v-img
                                      :src="img.url"
                                      :lazy-src="img.url"
                                      aspect-ratio="1"
                                      class="grey lighten-2 mx-auto"
                                      slot-scope="{ hover }"
                                      :class="`elevation-${hover ? 12 : 2}`"
                                      @click="viewMedia(img.url)"
                                      v-else
                                    />
                                  </v-hover>
                                </v-card>
                              </v-col>
                              <v-col md="12" xs="12" class="pt-0" v-if="post.label && getPostType(allPost.type) === 'url'">
                                <a :href="post.label" target="_blank">
                                  <v-btn small text color="warning" class="mt-2"> {{ post.label }}</v-btn>
                                </a>
                              </v-col>
                            </v-row>
                            <v-divider class="mb-4"></v-divider>
                          </div>
                        </div>
                      </div>
                      <!-- Old Images -->
                      <v-row justify="center" align="center" v-if="imagesToView.images && imagesToView.images.length > 0">
                        <v-col v-for="img in imagesToView.images" :key="img.index" md="4" xs="12">
                          <v-card text tile>                      
                            <v-hover>
                              <video
                              width="180px"
                              height="200px"
                              v-if="getMediaType(img.url) === 'video'"
                              :src="img.url"
                              controls>             
                                  Your browser does not support the video tag.
                              </video>
                              <v-img
                                :src="img.url"
                                :lazy-src="img.url"
                                aspect-ratio="1"
                                class="grey lighten-2 mx-auto"
                                slot-scope="{ hover }"
                                :class="`elevation-${hover ? 12 : 2}`"
                                @click="viewMedia(img.url)"
                                v-else
                              />
                            </v-hover>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        xs="12"
                      >
                        <upload-media
                        accept="*" 
                        @change="mediaChanged" 
                        :multiple="true"
                        :listMedia="media"></upload-media>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  xs="12"
                >
                  <v-btn
                  color="warning"
                  small
                  @click="extractData()"
                  v-if="uploadMedias.length || selectedImages.length">
                    Extract with AI
                  </v-btn>
                </v-col>
              </v-row>
              <div v-if="dataResult">
                <v-row v-if="postType === 'tiktok'">
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Total Play Time:</span>
                      <span>{{dataResult.total_play_time || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                    <span>Average Watch Time (s):</span><span></span>
                    <span>{{dataResult.average_watch_time_seconds || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Likes:</span>
                    <span>{{dataResult.likes || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Comments:</span>
                      <span>{{dataResult.comments || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Shares:</span>
                      <span>{{dataResult.shares || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Favourites (Bookmarks):</span>
                      <span>{{dataResult.bookmarks || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Plays (Views):</span>
                      <span>{{dataResult.video_views || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Total Viewers (Reach):</span>
                      <span>{{dataResult.reached || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Watched full video (%):</span>
                      <span v-if="dataResult.watched_full_video_percentage">{{dataResult.watched_full_video_percentage}}%</span>
                      <span v-else>N/A</span>
                    </p>
                  </v-col>
                </v-row>
                <v-row v-else-if="postType === 'reel'">
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Accounts Reached:</span>
                      <span>{{dataResult.reached || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Plays (Views):</span>
                      <span>{{dataResult.video_views || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Likes:</span>
                    <span>{{dataResult.likes || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Saves (Bookmarks):</span>
                      <span>{{dataResult.bookmarks || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Shares:</span>
                      <span>{{dataResult.shares || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Comments:</span>
                      <span>{{dataResult.comments || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Total Play Time:</span>
                      <span>{{dataResult.total_play_time || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                     
                    >
                      <span>Average Watch Time:</span>
                      <span v-if="dataResult.reel_watch_time">{{dataResult.reel_watch_time}}</span>
                      <span v-else>N/A</span>
                    </p>
                  </v-col>
                </v-row>
                <v-row v-else-if="postType === 'story'">
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Accounts Reached:</span>
                      <span>{{dataResult.reached || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Impressions:</span>
                      <span>{{dataResult.impressions || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Replies:</span>
                      <span>{{dataResult.replies || 'N/A'}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Shares:</span>
                      <span>{{dataResult.shares || ''}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Link Clicks:</span>
                      <span>{{dataResult.link_clicks}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                    >
                      <span>Sticker Taps:</span>
                      <span>{{dataResult.sticker_taps || ''}}</span>
                    </p>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.average_watch_time_seconds"
                    >
                    <span>Average Watch Time (s):</span><span></span>
                    <span>{{dataResult.average_watch_time_seconds}}s</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.likes"
                    >
                      <span>Likes:</span>
                    <span>{{dataResult.likes}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.comments"
                    >
                      <span>Comments:</span>
                      <span>{{dataResult.comments}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.new_followers"
                    >
                      <span>Followers:</span>
                      <span>{{dataResult.new_followers}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.shares"
                    >
                      <span>Shares:</span>
                      <span>{{dataResult.shares}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.bookmarks"
                    >
                      <span>Saved:</span>
                      <span>{{dataResult.bookmarks}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.video_views"
                    >
                      <span>Views:</span>
                      <span>{{dataResult.video_views}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.reached"
                    >
                      <span>Reached:</span>
                      <span>{{dataResult.reached}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.replies"
                    >
                      <span>Replies:</span>
                      <span>{{dataResult.replies}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.link_clicks"
                    >
                      <span>Link Clicks:</span>
                      <span>{{dataResult.link_clicks}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.link_clicks"
                    >
                      <span>Sticker Taps:</span>
                      <span>{{dataResult.sticker_taps}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.total_interactions"
                    >
                      <span>Total Interactions:</span>
                      <span>{{dataResult.total_interactions}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.total_play_time"
                    >
                      <span>Total Play Time:</span>
                      <span>{{dataResult.total_play_time}}</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.watched_full_video_percentage"
                    >
                      <span>Average Watch Time:</span>
                      <span>{{dataResult.watched_full_video_percentage}}%</span>
                    </p>
                    <p
                      class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                      v-if="dataResult.reel_watch_time"
                    >
                      <span>Average Watch Time:</span>
                      <span>{{dataResult.reel_watch_time}}</span>
                    </p>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <!-- Footer -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeModal"> Close </v-btn>
              <v-btn class="success" v-if="dataResult" @click="confirmStats">Proceed</v-btn>
            </v-card-actions>
          </v-card>
      </v-card>
      <loading :active.sync="isLoading" 
      :can-cancel="false" 
      :is-full-page="true">
      </loading>
      <v-dialog
        v-model="imageViewerDialog"
        max-width="700"
        >
        <v-card>
          <v-card-title
            class="grey lighten-2"
            primary-title
          >
            <v-spacer></v-spacer>
            <v-icon @click="imageViewerDialog = false">close</v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <v-img :src="activeImage"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <a :href="activeImage" download target="_blank">
              <v-btn><v-icon float-left>save_alt</v-icon>Download</v-btn>
            </a>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import UploadMedia from '../post/UploadMediaForStats';
import campaignAPIs from '../../views/Campaign/campaignAPIs';
import Loading from 'vue-loading-overlay'
import uniq from 'lodash/uniq';
export default {
  name: 'UploadStatsModal',
  components: {
    UploadMedia,
    Loading
  },
  props: {
    value: Boolean,
    postType: String,
    imagesToView: Object
  },
  data () {
    return {
      media: [],
      uploadMedias: [],
      selectedImages: [],
      mediaUrl: '',
      dataResult: null,
      isLoading: false,
      previewMedia: '',
      imageViewerDialog: false,
      checkedContent: false,
      checkedStory: false,
      checkedPost: false,
      base64Image: '',
      checkbox: {
        content: ''
      },
      activeTab: null
    }
  },
  watch: {
    value: function(newValue) {
      if (newValue === true) {
        this.media = []
        this.mediaUrl = ''
        this.dataResult = null
        this.selectedImages = []
      }
    }
  },
  computed: {
    hasPosts: function() {
      if (this.imagesToView) {
        if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
          for (let post of this.imagesToView.posts) {
            if (post.instagramPostURL !== '' || (post.images && post.images.length > 0)) {
              return true
            }
          }
        }
      }
      return false
    },
    hasStories: function() {
      if (this.imagesToView) {
        if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
          for (let post of this.imagesToView.stories) {
            if (post.label !== '' || (post.images && post.images.length > 0)) {
              return true
            }
          }
        }
      }
      return false
    },
    hasDeliverablePosts: function() {
      if (this.imagesToView) {
        if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
          for (let allPosts of this.imagesToView.deliverablePosts) {
            for (let post of allPosts.posts) {
              if (post.label !== '' || (post.images && post.images.length > 0)) {
                return true
              }
            }
          }
        }
      }
      return false
    }
  },
  methods: {
    confirmStats: function () {
      this.closeModal()
      this.$emit('statsConfirmed', this.dataResult)
      return;
    },
    closeModal: function () {
      this.$emit('input')
    },
    async mediaChanged(media) {
      this.uploadMedias = Object.assign([], media)
    },
    async extractData() {
      this.isLoading = true
      let vm = this
      if (this.selectedImages.length) {
        vm.selectedImages = uniq(vm.selectedImages)
        for (let ret of this.selectedImages) {
          // let ret = await this.convertImageToBase64(s)
          this.uploadMedias.push(ret)
        }
      }
      vm.uploadMedias = vm.uploadMedias.filter(v => v !== '')
      if (!vm.uploadMedias.length) return
      if (Array.isArray(vm.uploadMedias)) {
        vm.uploadMedias = vm.uploadMedias.map(m => {
          if (m.preview) {
            if (m.preview.src) {
              m = m.preview.src
            }
          }
          return m
        })
        if (vm.uploadMedias.length) {
          vm.dataResult = await campaignAPIs.uploadAIStatsData({
            medias: vm.uploadMedias
          })
          vm.uploadMedias = []
        }
      }
      vm.isLoading = false
    },
    viewMedia(media) {
      this.imageViewerDialog = true
      this.activeImage = media
    },
    toggleImage(img) {
      // Logic to add/remove image from selectedImages
      if (!this.selectedImages.includes(img)) {
        this.selectedImages = this.selectedImages.filter(s => s !== img)
      } else {
        this.selectedImages.push(img);
      }
    },
    changeContentImage(posts) {
      this.selectedImages = []
      if (this.checkedContent) {
        this.checkedContent = false
      } else {
        this.checkbox.story = ''
        this.checkbox.post = ''
        this.checkedContent = true
      }
      for (let post of posts) {
        for (let image of post.images) {
          if (this.checkbox.content) {
            if (!image.isvideo) {
              this.selectedImages.push(image.url)
            }
          } else {
            this.selectedImages = this.selectedImages.filter(sImg => sImg !== image.url)
          }
        }
      }
    },
    changeStoryImage(posts) {
      this.selectedImages = []
      if (this.checkedStory) {
        this.checkedStory = false
      } else {
        this.checkbox.post = ''
        this.checkbox.content = ''
        this.checkedStory = true
      }
      for (let post of posts) {
        for (let image of post.images) {
          if (this.checkbox.story) {
            if (!image.isvideo) {
              this.selectedImages.push(image.url)
            }
          } else {
            this.selectedImages = this.selectedImages.filter(sImg => sImg !== image.url)
          }
        }
      }
    },
    changePostImage(posts) {
      this.selectedImages = []
      if (this.checkedPost) {
        this.checkedPost = false
      } else {
        this.checkbox.story = ''
        this.checkbox.content = ''
        this.checkedPost = true
      }
      for (let post of posts) {
        for (let image of post.images) {
          if (this.checkbox.post) {
            if (!image.isvideo) {
              this.selectedImages.push(image.url)
            }
          } else {
            this.selectedImages = this.selectedImages.filter(sImg => sImg !== image.url)
          }
        }
      }
    },
    async convertImageToBase64(imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        // Use a Promise to wait for the FileReader to finish
        const base64Image = await new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject; // Handle any errors
        });
        return base64Image; // Set the Base64 image
      } catch (error) {
        console.error('Error converting image to Base64:', error);
      }
    },
    getPostType(type) {
      if (type === 'IGS') {
        return 'label'
      } else return 'url'
    },
    filterEmptyPosts(posts) {
      posts = posts.filter(post => {
        if (post.label || post.images.length > 0) {
          return true
        }
        return false
      })
      return posts
    },
    getLongPostTitle(title) {
      if (title === 'TTP') {
        return `TikTok Post`
      } else if (title === 'IGP') {
        return `IG Post`
      } else if (title === 'IGC') {
        return `IG Carousel`
      } else if (title === 'IGS') {
        return `IG Story`
      } else if (title === 'IGV') {
        return `IG Video`
      } else if (title === 'IGR') {
        return `IG Reel`
      } else return title
    },
    getMediaType(mediaUrl) {
      const videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4']
      const images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP']
      const url = new URL(mediaUrl)
      const extension = url.pathname.split('.')[4] // our media url come with long lengh and array[4] only return the extension
      if (videos.includes(extension)) {
        return 'video'
      } else if (images.includes(extension)) {
        return 'image'
      } else {
        return 'image'
      }
    }
  }
}
</script>
<style scoped>
  .custom-font span {
    font-weight: 500;
  }
  .primary--text .v-tab--active {
    background: #3F3FFF!important;
    color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// UploadStatsModal.vue?632fbb1e